"use client";
import { atom } from "jotai";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

const storage = createJSONStorage<any>(() =>
  typeof window !== "undefined" ? localStorage : ({} as Storage),
);

export const persistAtomEffect = <T>(key: string, defaultValue: T) => {
  return atomWithStorage<T>(key, defaultValue, storage, {
    getOnInit: true,
  });
};

export const ssrCompletedState = atom(false);

export const useSsrComplectedState = () => {
  return (set: (val: boolean) => void) => set(true);
};
